/* Kelisya golden scratch ticket for Klaviyo forms.
   Klaviyo strips <script> from form HTML, so this file lives in the Shopify theme.
   It watches the page for .ks-card elements (Klaviyo renders forms late), turns the
   static silver panel into a scratchable canvas, and keeps the CLAIM button hidden
   until enough of the ticket is scratched. */
(function () {
  if (window.__klsScratchLoaded) return;
  window.__klsScratchLoaded = true;

  var REVEAL_AT = 0.55;      // share of the ticket that must be cleared
  var BRUSH = 0.075;        // brush radius as a share of panel width
  var CLAIM_TEXT = /^\s*claim\s*$/i;

  // Fonts used by the ticket, loaded only once a ticket is on the page (no-op if the theme already loads them)
  function loadFonts() {
    if (document.getElementById('kls-fonts')) return;
    var link = document.createElement('link');
    link.id = 'kls-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;0,700;1,700&family=Poppins:wght@500;600;700&display=swap';
    document.head.appendChild(link);
  }

  function formRoot(card) {
    return card.closest('form') || card.closest('[role="dialog"]') || document;
  }

  function claimButtons(card) {
    var root = formRoot(card);
    var found = Array.prototype.slice.call(root.querySelectorAll('.ks-claim'));
    if (!found.length) {
      found = Array.prototype.filter.call(root.querySelectorAll('button'), function (b) {
        return CLAIM_TEXT.test(b.textContent || '');
      });
    }
    return found;
  }

  function lockClaim(card) {
    claimButtons(card).forEach(function (el) {
      el.classList.add('ks-claim-anim', 'ks-claim-locked');
      el.setAttribute('aria-hidden', 'true');
      el.tabIndex = -1;
    });
  }

  function unlockClaim(card) {
    claimButtons(card).forEach(function (el) {
      el.classList.remove('ks-claim-locked');
      el.removeAttribute('aria-hidden');
      el.removeAttribute('tabindex');
    });
  }

  function paintFoil(ctx, w, h) {
    // Silver scratch-off foil, like a real lottery ticket
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#8e9196');
    g.addColorStop(0.22, '#e9ebee');
    g.addColorStop(0.4, '#a9adb3');
    g.addColorStop(0.55, '#f7f8f9');
    g.addColorStop(0.75, '#9da1a7');
    g.addColorStop(1, '#d9dce0');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);

    // Diagonal foil hatching
    ctx.save();
    ctx.strokeStyle = 'rgba(255,255,255,0.22)';
    ctx.lineWidth = Math.max(1, w / 260);
    for (var x = -h; x < w; x += w / 40) {
      ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke();
    }
    ctx.restore();

    // Metallic grain
    var n = Math.round(w * h / 70);
    for (var i = 0; i < n; i++) {
      ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,255,255,0.35)' : 'rgba(60,64,70,0.12)';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.3, 1.3);
    }

    // Label
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var fs = Math.round(h * 0.2);
    ctx.font = '700 ' + fs + 'px "Poppins", Arial, sans-serif';
    if (ctx.letterSpacing !== undefined) ctx.letterSpacing = Math.round(fs * 0.3) + 'px';
    ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText('\u2726  SCRATCH HERE  \u2726', w / 2, h / 2 + 1);
    ctx.fillStyle = '#3d4046';
    ctx.fillText('\u2726  SCRATCH HERE  \u2726', w / 2, h / 2);
  }

  function burst(card, dust) {
    var ctx = dust.getContext('2d');
    var w = dust.width, h = dust.height, dpr = window.devicePixelRatio || 1;
    var parts = [];
    for (var i = 0; i < 70; i++) {
      var a = Math.random() * Math.PI * 2, s = (1.5 + Math.random() * 4) * dpr;
      parts.push({ x: w / 2, y: h / 2, vx: Math.cos(a) * s, vy: Math.sin(a) * s - 2 * dpr,
        r: (1 + Math.random() * 2.5) * dpr, life: 1, c: Math.random() < 0.5 ? '#d6b264' : '#f8ecc4' });
    }
    function frame() {
      ctx.clearRect(0, 0, w, h);
      var alive = false;
      parts.forEach(function (p) {
        if (p.life <= 0) return;
        alive = true;
        p.x += p.vx; p.y += p.vy; p.vy += 0.12 * dpr; p.life -= 0.018;
        ctx.globalAlpha = Math.max(0, p.life);
        ctx.fillStyle = p.c;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      });
      ctx.globalAlpha = 1;
      if (alive) requestAnimationFrame(frame); else ctx.clearRect(0, 0, w, h);
    }
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) frame();
  }

  function setup(card) {
    if (card.__kls) return;
    var panel = card.querySelector('.ks-panel') || card;
    var rect = panel.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    if (rect.width < 40 || rect.height < 20) return; // not laid out yet, retry on next mutation
    card.__kls = true;
    loadFonts();

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.round(rect.width * dpr), h = Math.round(rect.height * dpr);

    var canvas = document.createElement('canvas');
    canvas.className = 'ks-canvas';
    canvas.width = w; canvas.height = h;
    canvas.setAttribute('aria-label', 'Scratch card. Drag across to reveal your prize.');
    var dust = document.createElement('canvas');
    dust.className = 'ks-dust';
    dust.width = Math.round(cardRect.width * dpr); dust.height = Math.round(cardRect.height * dpr);
    var hint = document.createElement('span');
    hint.className = 'kls-hint';
    var a11y = document.createElement('button');
    a11y.type = 'button';
    a11y.className = 'ks-a11y';
    a11y.textContent = 'Reveal my prize';

    panel.appendChild(canvas);
    panel.appendChild(hint);
    card.appendChild(dust);
    card.appendChild(a11y);

    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    paintFoil(ctx, w, h);
    // Repaint once web fonts arrive so the label uses Poppins
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (!revealed && !touched) paintFoil(ctx, w, h); });
    }
    card.classList.add('is-ready');
    lockClaim(card);

    var revealed = false, touched = false, drawing = false, last = null, moves = 0;
    var radius = w * BRUSH;
    function dropHint() { if (hint.parentNode) hint.parentNode.removeChild(hint); }

    function pos(e) {
      var r = canvas.getBoundingClientRect();
      return { x: (e.clientX - r.left) * (w / r.width), y: (e.clientY - r.top) * (h / r.height) };
    }

    function scratch(p) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = radius * 2;
      ctx.beginPath();
      if (last) ctx.moveTo(last.x, last.y); else ctx.moveTo(p.x - 0.1, p.y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      ctx.globalCompositeOperation = 'source-over';
      last = p;
    }

    function cleared() {
      // Sample a coarse grid instead of every pixel
      var data = ctx.getImageData(0, 0, w, h).data, step = 5 * dpr, total = 0, clear = 0;
      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          total++;
          if (data[(Math.floor(y) * w + Math.floor(x)) * 4 + 3] < 40) clear++;
        }
      }
      return clear / total;
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      card.classList.add('is-revealed');
      dropHint();
      canvas.removeAttribute('aria-label');
      unlockClaim(card);
      burst(card, dust);
      try { if (navigator.vibrate) navigator.vibrate(30); } catch (err) {}
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (revealed) return;
      drawing = true; touched = true; last = null;
      dropHint();
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      scratch(pos(e));
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drawing || revealed) return;
      scratch(pos(e));
      if (++moves % 6 === 0 && cleared() >= REVEAL_AT) reveal();
      e.preventDefault();
    });
    function stop() {
      if (!drawing) return;
      drawing = false; last = null;
      if (!revealed && cleared() >= REVEAL_AT) reveal();
    }
    canvas.addEventListener('pointerup', stop);
    canvas.addEventListener('pointercancel', stop);
    canvas.addEventListener('pointerleave', stop);
    a11y.addEventListener('click', reveal);
  }

  function scan() {
    var cards = document.querySelectorAll('.ks-card');
    for (var i = 0; i < cards.length; i++) setup(cards[i]);
  }

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', scan);
  scan();
})();
